import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import socketIOClient from 'socket.io-client';

import config from '../../config';
import CardView from '../../components/Card/CardView';
import PatientInfo from '../../components/Profile/PatientInfo';
import Summary from './components/Tab/summary';
import Event from './components/Tab/event';
import Sleep from './components/Tab/sleep';
import Location from './components/Tab/location';
import ActivityDetails from './components/Tab/activityDetails';
import LocationDetails from './components/Tab/locationDetails';
import DeviceUsage from './components/Tab/deviceUsage';
import VitalsignDetails from './components/Tab/vitalsign';
import GarminWatch from './components/Tab/garminWatch';
// import AllChart from "./components/Tab/allChart";
import Navbar from './components/Navbar/Navbar';
import Dialog from '../../components/Dialog/Dialog';
import PatientSummaryAlert from './components/Tab/patientSummaryAlert';

class SummaryReportPage extends Component {
  constructor(props) {
    super(props);
    this.dataChartAction = this.dataChartAction.bind(this);
    this.dataChartAlert = this.dataChartAlert.bind(this);
    this.dataChartMovement = this.dataChartMovement.bind(this);
    this.dataChartLocation = this.dataChartLocation.bind(this);
    this.dataChartBattery = this.dataChartBattery.bind(this);
    this.dataChartDeviceUsage = this.dataChartDeviceUsage.bind(this);
    this.dataChartHRVsTemp = this.dataChartHRVsTemp.bind(this);
    this.dataChartSpo2 = this.dataChartSpo2.bind(this);
    this.dataChartRespirationRate = this.dataChartRespirationRate.bind(this);
    this.dataChartBloodPressure = this.dataChartBloodPressure.bind(this);

    // this.subscribeToServer();
    this.socket = null;
    this.internalDataLocation = [];
  }

  state = {
    tab: localStorage.getItem('role') === 'Field Hospital' ? 5 : 0,
    // tab: 0,
    date: new Date().toDateString(),
    startDate: new Date(),
    zoomActivity: 0,
    zoomLocation: 0,
    zoomBattery: 0,
    zoomDevice: 0,
    zoomVitalsign: 0,
    action: {
      changed: {
        a: null,
        f: null,
        b: null,
        m: null,
      },
    },
    toggle: false,
    isSetting: false,
    isInfo: false,
    isAlert: false,
    value: '',
    viewType: 'week',
    displayViewType: 'daily',
    isShowMinMax: true,
    lyingOnBack: true,
    lyingOnStomach: true,
    lyingOnLeft: true,
    lyingOnRight: true,
    lying: true,
    sitting: true,
    standing: true,
    walking: true,
    total: false,
    lyingTotal: false,
    tooltip: {
      display: 'none',
      name: '',
      layerX: 0,
      layerY: 0,
      hoverTxt: 0,
    },
    settingPosition: {
      x: 0,
      y: 0,
    },
    devices: [],
    deviceAirnode: null,
    heartrate: false,
    respiration: false,
    spo2: false,
    vitalsigns: [],
    viewSubTypeForYear: {
      sleep: 'summary', //this state used for 'sleep.js'. possible values ​​are 'average' , 'summary'
      location: 'summary', //this state used for 'location.js'. possible values ​​are 'average' , 'summary'
      event: 'summary', //this state used for 'event.js'. possible values ​​are 'average' , 'summary'
    },
  };

  async componentDidMount() {
    this.subscribeToServer();
  }

  async componentWillUnmount() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.close();
      this.socket = null;
    }
  }

  async subscribeToServer() {
    let { data } = this.props;
    this.socket = socketIOClient(`${config.api.url_socket}`);
    if (data.patient) {
      this.socket.on(`patient_action_${data.patient.id}`, async (payload) => {
        console.log('payload patient action ---> ', payload);
        await this.setPayload(payload);
      });
    }
    // if (localStorage.getItem("select_module")) {
    //   const selectModule = JSON.parse(localStorage.getItem("select_module"));
    //   (selectModule || []).forEach((val) => {
    //     this.socket.on(`module_action_${val}`, async (payload) => {
    //       // console.log('payload action summary ---> ',payload);
    //       await this.setPayload(payload);
    //     });
    //   });
    // }
  }

  async setPayload(payload) {
    const { data } = this.props;
    if (payload.length > 0) {
      if (config.groupNotification) {
        let devices = [];
        (payload || []).forEach((payload) => {
          payload.data.notifications.forEach((notif) => {
            const tmp = data.patient.devices.find((d) => d.serial === notif.deviceSerial);
            if (tmp) {
              tmp['action'] = notif;
              if (tmp['action'].changed && typeof tmp['action'].changed === 'string') {
                tmp['action'].changed = JSON.parse(tmp['action'].changed);
              }
              if (tmp.deviceVersion && tmp.deviceVersion.category === 'AIRNODE') {
                this.setState({
                  action: tmp.action,
                });
              }

              devices.push(tmp);
            }
          });
          return payload;
        });

        this.setState({ devices });
      }
    }
  }

  dataChartAction(chart) {
    this.internalDataChart = chart;
  }

  dataChartAlert(chart) {
    this.internalDataAlert = chart;
  }

  dataChartMovement(chart) {
    this.internalDataMovement = chart;
  }

  dataChartLocation(chart) {
    this.internalDataLocation.push(chart);
  }

  dataChartBattery(chart) {
    this.internalDataBattery = chart;
  }

  dataChartDeviceUsage(chart) {
    this.internalDataDeviceUsage = chart;
  }

  dataChartHRVsTemp(chart) {
    this.internalDataHRVsTemp = chart;
  }

  dataChartSpo2(chart) {
    this.internalDataSpo2 = chart;
  }

  dataChartRespirationRate(chart) {
    this.internalDataRespirationRate = chart;
  }

  dataChartBloodPressure(chart) {
    this.internalDataBloodPressure = chart;
  }

  resetZoomAll = async (event) => {
    this.setState({ zoomActivity: 0 });
    this.internalDataChart &&
      Object.keys(this.internalDataChart).length > 0 &&
      (await this.internalDataChart.zoomOut());
    this.internalDataMovement &&
      Object.keys(this.internalDataMovement).length > 0 &&
      (await this.internalDataMovement.zoomOut());
    localStorage.getItem('role_id') === '1' &&
      this.internalDataAlert &&
      Object.keys(this.internalDataAlert).length > 0 &&
      (await this.internalDataAlert.zoomOut());
  };

  resetZoomLocation = async (event) => {
    this.setState({ zoomLocation: 0 });
    if (event) {
      if (this.internalDataLocation.length > 0) {
        for (const v of this.internalDataLocation) {
          Object.keys(v).length > 0 && (await v.zoomOut());
        }
      }
    } else {
      this.internalDataLocation = [];
    }
  };

  resetZoomDevice = async (event) => {
    this.setState({ zoomDevice: 0 });
    this.internalDataBattery && (await this.internalDataBattery.zoomOut());
    this.internalDataDeviceUsage && (await this.internalDataDeviceUsage.zoomOut());
  };

  resetZoomVitalsign = async () => {
    this.setState({ zoomVitalsign: 0 });
    this.internalDataHRVsTemp &&
      Object.keys(this.internalDataHRVsTemp).length > 0 &&
      (await this.internalDataHRVsTemp.zoomOut());
    this.internalDataSpo2 && Object.keys(this.internalDataSpo2).length > 0 && (await this.internalDataSpo2.zoomOut());
    this.internalDataRespirationRate &&
      Object.keys(this.internalDataRespirationRate).length > 0 &&
      (await this.internalDataRespirationRate.zoomOut());
    this.internalDataBloodPressure &&
      Object.keys(this.internalDataBloodPressure).length > 0 &&
      (await this.internalDataBloodPressure.zoomOut());
  };

  syncZoom = (event, task) => {
    const extremesObject = event.xAxis[0];
    switch (task) {
      case 'activity':
        this.setState({ zoomActivity: 1 });
        if (this.internalDataMovement) {
          this.internalDataMovement.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataAlert) {
          this.internalDataAlert.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'movement':
        this.setState({ zoomActivity: 1 });
        if (this.internalDataChart) {
          this.internalDataChart.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataAlert) {
          this.internalDataAlert.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'location':
        this.setState({ zoomLocation: 1 });
        if (this.internalDataLocation.length > 0) {
          for (const v of this.internalDataLocation) {
            v.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
          }
        }
        break;
      case 'device':
        this.setState({ zoomDevice: 1 });
        if (this.internalDataBattery) {
          this.internalDataBattery.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataDeviceUsage) {
          this.internalDataDeviceUsage.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      default:
        this.setState({ zoomActivity: 1 });
        if (this.internalDataChart) {
          this.internalDataChart.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataMovement) {
          this.internalDataMovement.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
    }
  };

  syncZoomVitalsign = (event, task) => {
    const extremesObject = event.xAxis[0];
    switch (task) {
      case 'HRVsTemp':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataSpo2) {
          this.internalDataSpo2.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataRespirationRate) {
          this.internalDataRespirationRate.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataBloodPressure) {
          this.internalDataBloodPressure.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'spo2':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataHRVsTemp) {
          this.internalDataHRVsTemp.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataRespirationRate) {
          this.internalDataRespirationRate.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataBloodPressure) {
          this.internalDataBloodPressure.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'respirationRate':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataHRVsTemp) {
          this.internalDataHRVsTemp.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataSpo2) {
          this.internalDataSpo2.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataBloodPressure) {
          this.internalDataBloodPressure.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      case 'bloodpressure':
        this.setState({ zoomVitalsign: 1 });
        if (this.internalDataHRVsTemp) {
          this.internalDataHRVsTemp.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataRespirationRate) {
          this.internalDataRespirationRate.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        if (this.internalDataSpo2) {
          this.internalDataSpo2.series[0].xAxis.setExtremes(extremesObject.min, extremesObject.max);
        }
        break;
      default:
        break;
    }
  };

  handleChange = (event) => {
    let tab = +event.target.getAttribute('set-key');
    this.setState({ tab, zoom: 0, zoomActivity: 0, zoomLocation: 0, zoomVitalsign: 0 });
    if (tab === 7) {
      const startDate = this.getPrevDate(this.state.viewType, this.state.date);
      this.setState({ startDate });
    } else if (tab === 8) {
      const startDate = this.getPrevDate(this.state.displayViewType, this.state.date);
      this.setState({ startDate });
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  onDateChange = async (value) => {
    const { data } = this.props;
    // donot reload data if user select same date
    const newDate = value.toDateString();
    if (this.state.date === newDate) {
      return;
    }
    this.setState({
      date: value.toDateString(),
    });
    this.props.vitalsign.resetVitalSigns();
    this.props.summary.resetSummary(false);

    let queryOption = {};
    if (localStorage.getItem('role_id') === '1') {
      queryOption = {
        activity: true,
        movement: true,
        alert: true,
        location: true,
        battery: true,
        admin: true,
        device: true,
      };
    } else {
      queryOption = {
        activity: true,
        movement: true,
        location: true,
      };
    }
    this.props.summary.getSummary(data.patient && data.patient.id, value, queryOption);

    if (this.state.viewType === 'month') {
      this.props.vitalsign.setSinceData(30);
    } else if (this.state.viewType === 'year') {
      this.props.vitalsign.setSinceData(365);
    } else {
      this.props.vitalsign.setSinceData(7);
    }
    const { since } = this.props.vitalsign.toJS();

    const queryLastVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
    };

    const querySummaryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
      since,
    };

    this.props.summary.getSummaryReport(data.patient && data.patient.id, value);
    this.props.summary.getSummaryReportAsPeriod(data.patient.id, value, this.state.viewType, ['sleep', 'event']);
    this.props.summary.getSummaryLocationAsPeriod(data.patient.id, value, this.state.viewType);
    this.props.vitalsign.getLastVitalSign(data.patient && data.patient.id, value, queryLastVitalsign);
    this.props.vitalsign.getSummaryVitalSign(data.patient && data.patient.id, value, querySummaryVitalsign);

    config.features.report.garmin &&
      this.props.smartwatchsummary.summaryVitalSigns(
        data.patient && data.patient.id,
        value,
        this.state.displayViewType,
        ['heartrate', 'spo2', 'respiration'],
      );

    // reset zoom
    this.resetZoomAll();
    this.resetZoomLocation();
    this.resetZoomVitalsign();
  };

  /**
   * event handler for on changing viewSubTypeForYear state
   * changeFor -  'sleep' , 'event' , 'location'
   * viewSubTypeForYear -  'average' , 'summary'
   * */
  onChangeViewSubTypeForYear = (changeFor, viewSubTypeForYear) => {
    const stateviewSubTypeForYear = { ...this.state.viewSubTypeForYear };
    if (changeFor === 'sleep') {
      stateviewSubTypeForYear.sleep = viewSubTypeForYear;
    } else if (changeFor === 'event') {
      stateviewSubTypeForYear.event = viewSubTypeForYear;
    } else if (changeFor === 'location') {
      stateviewSubTypeForYear.location = viewSubTypeForYear;
    } else {
      return;
    }
    this.setState({
      viewSubTypeForYear: stateviewSubTypeForYear,
    });
  };

  onChangePeriod = (viewType) => {
    const { data } = this.props;
    this.setState({ viewType });
    this.props.summary.getSummaryReportAsPeriod(data.patient.id, new Date(this.state.date), viewType, [
      'sleep',
      'event',
    ]);
    this.props.summary.getSummaryLocationAsPeriod(data.patient.id, new Date(this.state.date), viewType);
  };

  onChangeLocationPeriod = (viewType) => {
    const { data } = this.props;
    this.setState({ viewType });
    this.props.summary.getSummaryLocationAsPeriod(data.patient.id, new Date(this.state.date), viewType);
  };

  onChangeVitalsignPeriod = (viewType) => {
    const { data } = this.props;
    const startDate = this.getPrevDate(viewType, this.state.date);
    this.setState({ viewType, startDate });

    if (viewType === 'month') {
      this.props.vitalsign.setSinceData(30);
    } else if (viewType === 'year') {
      this.props.vitalsign.setSinceData(365);
    } else {
      this.props.vitalsign.setSinceData(7);
    }
    const { since } = this.props.vitalsign.toJS();
    const querySummaryVitalsign = {
      heartrate: true,
      temperature: true,
      bloodPressure: true,
      spo2: true,
      respirationRate: true,
      since,
    };
    this.props.vitalsign.getSummaryVitalSign(data.patient.id, new Date(this.state.date), querySummaryVitalsign);
  };

  onChangeGarminWatchPeriod = async (displayViewType) => {
    const { data } = this.props;
    const startDate = this.getPrevDate(displayViewType, this.state.date);
    this.setState({ displayViewType, startDate });
    const date = new Date(this.state.date);
    config.features.report.garmin &&
      this.props.smartwatchsummary.summaryVitalSigns(data.patient.id, date, displayViewType, [
        'heartrate',
        'spo2',
        'respiration',
      ]);
  };

  getPrevDate(as, date) {
    let dateStart = null;
    switch (as) {
      case 'week':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'month':
        dateStart = moment(new Date(`${date}`))
          .subtract(4, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'year':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'y')
          .add(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'weekly':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'monthly':
        dateStart = moment(new Date(`${date}`))
          .subtract(4, 'w')
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'yearly':
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'y')
          .add(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'daily':
      default:
        dateStart = moment(new Date(`${date}`))
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
    }

    return dateStart;
  }

  getNextDate(as, date) {
    let dateStart = null;
    switch (as) {
      case 'week':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'month':
        dateStart = moment(new Date(`${date}`))
          .add(4, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'year':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'y')
          .subtract(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'weekly':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'monthly':
        dateStart = moment(new Date(`${date}`))
          .add(4, 'w')
          .subtract(1, 'd')
          .startOf('day')
          .toDate();
        break;
      case 'yearly':
        dateStart = moment(new Date(`${date}`))
          .add(1, 'y')
          .subtract(1, 'day')
          .startOf('day')
          .toDate();
        break;
      case 'daily':
      default:
        dateStart = moment(new Date(`${date}`))
          .add(1, 'd')
          .startOf('day')
          .toDate();
        break;
    }
    return dateStart;
  }

  handleBackButtonClick = (as) => {
    const startDate = this.getPrevDate(as, this.state.startDate);
    const endDate = this.getPrevDate(as, this.state.date);
    this.setState({
      startDate,
      date: endDate,
    });
    this.onDateChange(endDate);
  };

  handleNextButtonClick = (as) => {
    const startDate = this.getNextDate(as, this.state.startDate);
    const endDate = this.getNextDate(as, this.state.date);
    this.setState({
      startDate,
      date: endDate,
    });
    this.onDateChange(endDate);
  };

  handleChangeVitalsign = (value) => (event) => {
    let vitalsigns = this.state.vitalsigns;
    const checked = vitalsigns.find((data) => data === value);
    if (checked) {
      vitalsigns = vitalsigns.filter((data) => data !== value);
    } else {
      vitalsigns.push(value);
    }
    this.setState({
      [value]: event.target.checked,
      vitalsigns,
    });
  };

  handleShowMinMaxValue = () => {
    this.setState({ isShowMinMax: !this.state.isShowMinMax });
  };

  onSelect = (e) => {
    let { value } = e.target;
    if (value === 'total') {
      this.setState({
        total: !this.state.total,
        lying: this.state.total ? true : false,
        sitting: this.state.total ? true : false,
        standing: this.state.total ? true : false,
        walking: this.state.total ? true : false,
      });
    }
    if (value === 'lyingTotal') {
      this.setState({
        lyingTotal: !this.state.lyingTotal,
        lyingOnBack: this.state.lyingTotal ? true : false,
        lyingOnStomach: this.state.lyingTotal ? true : false,
        lyingOnLeft: this.state.lyingTotal ? true : false,
        lyingOnRight: this.state.lyingTotal ? true : false,
      });
    }
    if (value === 'lyingOnBack') {
      this.setState({
        lyingTotal: false,
        lyingOnBack: !this.state.lyingOnBack,
      });
    }
    if (value === 'lyingOnStomach') {
      this.setState({
        lyingTotal: false,
        lyingOnStomach: !this.state.lyingOnStomach,
      });
    }
    if (value === 'lyingOnLeft') {
      this.setState({
        lyingTotal: false,
        lyingOnLeft: !this.state.lyingOnLeft,
      });
    }
    if (value === 'lyingOnRight') {
      this.setState({
        lyingTotal: false,
        lyingOnRight: !this.state.lyingOnRight,
      });
    }
    if (value === 'lying') {
      this.setState({
        total: false,
        lying: !this.state.lying,
      });
    }
    if (value === 'sitting') {
      this.setState({
        total: false,
        sitting: !this.state.sitting,
      });
    }
    if (value === 'standing') {
      this.setState({
        total: false,
        standing: !this.state.standing,
      });
    }
    if (value === 'walking') {
      this.setState({
        total: false,
        walking: !this.state.walking,
      });
    }
  };

  onNoteChange = (key, value) => {
    this.setState({ value });
    this.props.patient.changeData(key, value);
  };

  onEditNote = (task) => {
    let { data } = this.props;
    this.setState({ toggle: !this.state.toggle });
    if (task === 'save') {
      this.props.patient.updateNote(data.patient.id);
    }
  };

  handleSetting = (e) => {
    const x = e.nativeEvent.offsetX;
    const y = e.nativeEvent.offsetY;
    this.setState({
      isSetting: !this.state.isSetting,
      settingPosition: {
        ...this.state.settingPosition,
        x: x,
        y: y,
      },
    });
  };

  handleAlert = (e) => {
    this.setState({
      isAlert: !this.state.isAlert,
    });
  };

  onMouseover = (layerX, layerY, value) => {
    this.setState({
      tooltip: {
        layerX,
        layerY,
        name: value.name,
        hoverTxt: value.hoverTxt,
        display: 'block',
      },
    });
  };

  onMouseout = () => {
    this.setState({
      tooltip: {
        layerX: 0,
        layerY: 0,
        name: '',
        hoverTxt: 0,
        display: 'none',
      },
    });
  };

  onOpenedInfo = () => {
    this.setState({
      isInfo: !this.state.isInfo,
    });
  };

  onAcknowledge = (alert, clearAlert = false) => {
    const { data } = this.props;
    const alerts = [];
    alerts.push({
      alertId: alert.alertId,
      alertType: alert.alertType,
    });
    this.props.dashboard.ackAlert(data, alerts);
    if (clearAlert) {
      this.setState({
        isAlert: false,
      });
    }
  };

  render() {
    const {
      tab,
      action,
      zoomActivity,
      zoomLocation,
      zoomVitalsign,
      isSetting,
      isAlert,
      viewType,
      displayViewType,
      lyingOnBack,
      lyingOnStomach,
      lyingOnRight,
      lyingOnLeft,
      lyingTotal,
      lying,
      total,
      walking,
      standing,
      sitting,
      tooltip,
      settingPosition,
      isInfo,
      isShowMinMax,
      heartrate,
      respiration,
      spo2,
      vitalsigns,
      viewSubTypeForYear,
    } = this.state;
    let { t, open, handleClose, data, currentAssignedDevice } = this.props;
    let {
      loadingAvailableDate,
      highlightDate,
      includeDate,
      summarySleepPeriod,
      summaryEventPeriod,
      summaryLocationPeriod,
      assignedDevicesDate,
      dateMotionTracker,
      dateSOS,
      dateBeaconTag,
      dateVitalSigns,
    } = this.props.summary.toJS();
    let note = this.props.patient.toJS();
    const { routers } = this.props.router.toJS();
    const role = localStorage.getItem('role');
    const today = moment().startOf('d').format('YYYY-MM-DD');
    const dateRef = moment(new Date(this.state.date)).format('YYYY-MM-DD');
    const assignDevice = (assignedDevicesDate || []).find((val) => {
      const dateFind = moment(new Date(val.date)).format('YYYY-MM-DD');
      return dateFind === dateRef;
    });
    const hasActivity =
      assignDevice && assignDevice.reportOptions
        ? assignDevice.reportOptions.hasActivity
        : currentAssignedDevice.reportOptions.hasActivity;
    const hasLocalization =
      assignDevice && assignDevice.reportOptions
        ? assignDevice.reportOptions.hasLocalization
        : currentAssignedDevice.reportOptions.hasLocalization;
    const devices = this.state.devices.length > 0 ? this.state.devices : data && data.patient && data.patient.devices;

    //const patientSummaryAlert = this.props.patientsummaryalert;

    return (
      <Dialog open={open} onClose={handleClose}>
        <div className='bg-primary-gradient'>
          <CardView>
            <div className='block w-full px-10 pt-10 xl:pt-4 lg:pt-4 md:pt-12 xl:px-20 lg:px-20 md:px-12'>
              <PatientInfo
                t={t}
                patient={data && data.patient}
                devices={devices}
                handleSetting={this.handleSetting}
                isSetting={isSetting}
                handleAlert={this.handleAlert}
                isAlert={isAlert}
                settingPosition={settingPosition}
                date={this.state.date}
                highlightDate={highlightDate}
                includeDate={includeDate}
                loadingAvailableDate={loadingAvailableDate}
                onDateChange={this.onDateChange}
                dateMotionTracker={dateMotionTracker}
                dateSOS={dateSOS}
                dateBeaconTag={dateBeaconTag}
                dateVitalSigns={dateVitalSigns}
                today={today}
                hasActivity={hasActivity}
                isInfo={isInfo}
                openedInfo={this.onOpenedInfo}
                onAcknowledge={this.onAcknowledge}
              />
              <div className='flex pt-4'>
                <Navbar
                  t={t}
                  tab={tab}
                  handleChange={this.handleChange}
                  // isEmergency={isEmergency}
                  role={role}
                />
              </div>
            </div>
          </CardView>
          {/* <div className="w-screen overflow-x-hidden overflow-y-scroll bg-transparent max-h-4/5"> */}
          <div className='w-screen pb-5 overflow-x-hidden overflow-y-scroll bg-primary-gradient content-height'>
            {tab === 0 && (
              <Summary
                t={t}
                action={action}
                devices={data.patient && data.patient.devices}
                patient={data.patient && data.patient}
                data={this.props.summary.toJS()}
                vitalsign={this.props.vitalsign.toJS()}
                note={note}
                routers={routers}
                alertType={data && data.alert && data.alert.alertType}
                role={role}
                // isEmergency={isEmergency}
                hasActivity={hasActivity}
              />
            )}
            {tab === 1 && (
              <Event
                t={t}
                data={summaryEventPeriod}
                date={this.state.date}
                onChangePeriod={this.onChangePeriod}
                viewType={viewType}
                onSelect={this.onSelect}
                display={{ total, lying, walking, standing, sitting }}
                onMouseover={this.onMouseover}
                onMouseout={this.onMouseout}
                tooltip={tooltip}
                hasActivity={hasActivity}
                viewSubTypeForYear={viewSubTypeForYear.event}
                onChangeViewSubTypeForYear={this.onChangeViewSubTypeForYear}
              />
            )}
            {tab === 2 && (
              <Sleep
                t={t}
                data={summarySleepPeriod}
                date={this.state.date}
                onChangePeriod={this.onChangePeriod}
                viewType={viewType}
                onSelect={this.onSelect}
                display={{
                  lyingTotal,
                  lyingOnBack,
                  lyingOnStomach,
                  lyingOnLeft,
                  lyingOnRight,
                }}
                onMouseover={this.onMouseover}
                onMouseout={this.onMouseout}
                tooltip={tooltip}
                hasActivity={hasActivity}
                viewSubTypeForYear={viewSubTypeForYear.sleep}
                onChangeViewSubTypeForYear={this.onChangeViewSubTypeForYear}
              />
            )}
            {tab === 3 && (
              <Location
                t={t}
                data={summaryLocationPeriod}
                date={this.state.date}
                onChangePeriod={this.onChangePeriod}
                viewType={viewType}
                onSelect={this.onSelect}
                onMouseover={this.onMouseover}
                onMouseout={this.onMouseout}
                tooltip={tooltip}
                hasActivity={hasActivity}
                hasLocalization={hasLocalization}
                viewSubTypeForYear={viewSubTypeForYear.location}
                onChangeViewSubTypeForYear={this.onChangeViewSubTypeForYear}
              />
            )}
            {tab === 4 && (
              <ActivityDetails
                zoom={Boolean(zoomActivity)}
                resetZoom={this.resetZoomAll}
                syncZoom={this.syncZoom}
                dataChartAction={this.dataChartAction}
                dataChartAlert={this.dataChartAlert}
                dataChartMovement={this.dataChartMovement}
                hasActivity={hasActivity}
              />
            )}
            {tab === 5 && (
              <LocationDetails
                zoom={Boolean(zoomLocation)}
                resetZoom={this.resetZoomLocation}
                syncZoom={this.syncZoom}
                dataChartLocation={this.dataChartLocation}
                hasLocalization={hasLocalization}
              />
            )}
            {tab === 6 && (
              <DeviceUsage
                syncZoom={this.syncZoom}
                dataChartBattery={this.dataChartBattery}
                dataChartDeviceUsage={this.dataChartDeviceUsage}
              />
            )}
            {tab === 7 && (
              <VitalsignDetails
                zoom={Boolean(zoomVitalsign)}
                syncZoom={this.syncZoomVitalsign}
                resetZoom={this.resetZoomVitalsign}
                dataChartHRVsTemp={this.dataChartHRVsTemp}
                dataChartSpo2={this.dataChartSpo2}
                dataChartRespirationRate={this.dataChartRespirationRate}
                dataChartBloodPressure={this.dataChartBloodPressure}
                onChangePeriod={this.onChangeVitalsignPeriod}
                viewType={viewType}
                endDate={this.state.date}
                startDate={this.state.startDate}
                handleBackButtonClick={this.handleBackButtonClick}
                handleNextButtonClick={this.handleNextButtonClick}
              />
            )}
            {tab === 8 && (
              <GarminWatch
                viewType={displayViewType}
                isShowMinMax={isShowMinMax}
                heartrate={heartrate}
                respiration={respiration}
                spo2={spo2}
                vitalsigns={vitalsigns}
                endDate={this.state.date}
                startDate={this.state.startDate}
                onChangePeriod={this.onChangeGarminWatchPeriod}
                handleChange={this.handleShowMinMaxValue}
                handleChangeVitalsign={this.handleChangeVitalsign}
                handleBackButtonClick={this.handleBackButtonClick}
                handleNextButtonClick={this.handleNextButtonClick}
              />
            )}
            {tab === 9 && (
              <PatientSummaryAlert
                t={t}
                //store={patientSummaryAlert}
                onEndDateChange={this.patientSummaryOnEndDateChanged}
              />
            )}
          </div>
        </div>
      </Dialog>
    );
  }

  patientSummaryOnEndDateChanged = async (date) => {
    this.onDateChange(date);
    this.setState({
      date: date,
    });
  };
}

export const page = inject(
  'summary',
  'bed',
  'patient',
  'dashboard',
  'router',
  'vitalsign',
  'smartwatchsummary',
  'patientsummaryalert',
)(observer(SummaryReportPage));
export const translation = withTranslation()(page);
export default translation;
